import React, { forwardRef } from 'react';
import cn from 'classnames';
import { PaginationVariantProps } from '../types';

import IconButton from '../../Buttons/IconButton';

const Carousel = forwardRef<HTMLDivElement, PaginationVariantProps>(
  (
    {
      currentPage = 1,
      totalPages = 1,
      onPrev,
      onNext,
      dark,
      white,
      className,
      ...other
    },
    ref,
  ) => (
    <div ref={ref} className={cn('flex items-center', className)} {...other}>
      <p
        className={`mr-40 font-gil text-16 leading-20 tracking-4 flex items-center justify-center flex-shrink-0 text-center ${
          dark ? 'text-white' : 'text-base-main'
        }`}
      >
        <span className="font-bold mr-4">{`${
          currentPage.toString().length < 2 ? 0 : ''
        }${currentPage}`}</span>
        {`/ ${totalPages.toString().length < 2 ? 0 : ''}${totalPages}`}
      </p>
      <IconButton
        className="flex-shrink-0 mr-16"
        arrow="left"
        darkMode={dark}
        white={white}
        disabled={currentPage <= 1}
        onClick={onPrev}
      />
      <IconButton
        className="flex-shrink-0"
        arrow="right"
        darkMode={dark}
        white={white}
        disabled={currentPage >= totalPages}
        onClick={onNext}
      />
    </div>
  ),
);

export default Carousel;
